import createModel, { prop } from './lib/create_model';

const AIAssistantMessage = createModel({
  modelName: 'AIAssistantMessage',

  properties: {
    original: prop(String),
    rephrased: prop(String),
    rationale: prop(String),
    isSuggested: prop(Boolean),
    isSkipped: prop(Boolean),
    advice: prop([String]),
    sentAt: prop(String),
    causedByItemIds: prop([String]),
    sentToCustomer: prop(Boolean),
    guideType: prop(String),
    guideId: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default AIAssistantMessage;
